import type { PointJson } from 'contracts/basic';
import type { Color, LineBasicMaterial } from 'three';
import { BufferGeometry, LineSegments, BufferAttribute } from 'three';

//eslint-disable-next-line no-restricted-imports
import { getLineMaterial } from '../../materials';

const maxIndices = 65535; //(size of Uint16Array less one)

export const parsePolylines = (
  //Note: Using Iterable<PointJson[]> rather than PointJson[][]
  //to make it easier to merge multiple polylines of an annotation into a
  //list of polylines using one iteration over the polylines. (using a generator function)
  //* Note: PointJson[][] is assignable to Iterable<PointJson[]>. Iterable<PointJson[]>
  //  is just more general whay to express the lines, giving more options such as using generator function.
  polylines: Iterable<PointJson[]>,
  color: Color | null,
): LineSegments<BufferGeometry, LineBasicMaterial>[] | undefined => {
  if (polylines) {
    const positionsChunks: number[][] = [[]];
    const indicesChunks: number[][] = [[]];

    let [positions] = positionsChunks;
    let [indices] = indicesChunks;

    let j = -1; //index in points
    for (const polyline of polylines) {
      if (positions.length + polyline.length * 3 > maxIndices) {
        positionsChunks.push((positions = []));
        indicesChunks.push((indices = []));
        j = -1;
      }

      for (const [i, point] of polyline.entries()) {
        positions.push(...point);
        // positions.push(...point.map(d => d * 25.4)); //To convert to mm
        j++;
        if (i > 0) {
          indices.push(j - 1);
          indices.push(j);
        }
      }
    }

    return positionsChunks.map((positions, i) => {
      const geometry = new BufferGeometry()
        .setAttribute(
          'position',
          new BufferAttribute(Float32Array.from(positions), 3),
        )
        .setIndex(new BufferAttribute(new Uint16Array(indicesChunks[i]), 1));
      return new LineSegments(geometry, getLineMaterial(color));
    });
  }
};
